import { defineAction } from './types';

export default defineAction({
  action: 'CREATE_SUITABILITY_REPORT',
  getHref: attrs => `/client/${attrs.client_id}/suitability-report`,
  getFollowUp: () => null,
  completionEvents: ['SUITABILITY_REPORT_GENERATED'],
});
